// import { React } from 'react'
import { toastr } from 'react-redux-toastr-custom'

const apiToToastMiddleware = store => next => action => {

	var regex = /([A-Z]*)_(CREATE|UPDATE)_(ERROR|SUCCESS)/g;

	if(regex.test(action.type)) {
		// eslint-disable-next-line
		var [ resource, verb, result ] = action.type.split('_');
	  switch(result) {
	    case 'SUCCESS':
	    	toastr.success('Resource saved successfully');
	    	break;
	    case 'ERROR':
	    	var msg = 'Please refresh and try again';
	    	var title = action.result.errorType === 'VERSION_CONFLICT'
	    	  ? 'Version conflict'
	    	  : 'Error';
	   		toastr.error.apply(toastr, [title, msg]);
	      break;
	     default:
	     	break;
	  }
    
	}

  return next(action);
}

export default apiToToastMiddleware;


// WEBPACK FOOTER //
// ./src/modules/toast/apiToToast.middleware.js